import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import * as constants from "../../widgetConstants.js";
import {getNoData} from "../../items/index.js";
import Widget from "../widget.js";
import {readRecords, readTargetRecord} from "../../../../indexedDB/index.js";
import u from "../../../../util/index.js";

export class AlarmWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    async getData() {
        let inputData = {
            ...this.$props.pageData,
            GUBUN: "0,1,2",
            MODE: "UNREAD",
        }

        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");
        return {recordData: data[this.$props.RECORD]};
    }

    async render() {
        $(this.$target).empty();
        $(this.$target).drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData('alarm'),
            callback: {
                scroll: () => {
                    this.setup.bind(this)({
                        isDataDrivenRendering: true,
                        isScrolling : true,
                    })                },
                item: getAlarmItemsHtml,
                final: this.mounted.bind(this)
            }
        })
    }

    mounted() {
        super.mounted();
        $(this.$target).find('.widget-article-list').removeClass('dash-pending')
        $(this.$target).find('.dash-num-pending').remove()
    }

    setEvent() {
        $(this.$target).off('click').on('click', (e) => {
            const $eTarget = $(e.target);
            if ($eTarget.closest('.js-alarm-item').length > 0) {
                AlarmClickEvent.clickAlarmUl(e);
            }
        })
    }

}

/*미확인 알림 아이템을 dom으로 변환하는 함수*/
const getAlarmItemsHtml = (alarmArray) => {
    return alarmArray && alarmArray.map(getAlarmItem).join('');
}

const getAlarmItem = (item) => {
    let {
        COLABO_COMMT_SRNO = "",
        COLABO_SRNO = "",
        COLABO_REMARK_SRNO = "",
        ALARM_ACTION = "",
        ALARM_STATUS = "",
        TTL = "",
        COMMT_TTL = "",
        RGSN_DTTM = "",
        ALAM_MSG = "",
        ALAM_CNTN = "",
        TASK_NM = "",
        EMT_CD = "",
        IMG_ATCH_YN = "N",
        ATCH_YN = "N",
    } = item

    const isTask = ("" !== TASK_NM);
    const isContainImg = ("Y" === IMG_ATCH_YN);
    const isContainFile = ("Y" === ATCH_YN);
    const isContainMsg = (!!ALAM_MSG || "" === ALAM_MSG || 'null' === ALAM_MSG);
    const isRejectProject = ("-3" === COLABO_COMMT_SRNO);
    const alarmContents = $.trim(TagConvert.db2TwoStringByAlarm(ALAM_CNTN));
    const alarmItemsHtmlContent = !isTask ? TagUtil.tag2html(alarmContents) : ListHelper.setEmTag(alarmContents, i18next.t(dictionary.context) + ":");
    const contents = TagUtil.n2br(alarmItemsHtmlContent);
    const task_name = isTask ? ListHelper.setEmTag((TASK_NM || COMMT_TTL), i18next.t(common.taskName) + " :") + (isTask ? '<br>' : '') : "";

    return `<li class="alarm-${COLABO_COMMT_SRNO} js-alarm-item js-all-post-item" 
                        colabo_srno="${COLABO_SRNO}" 
                        colabo_commt_srno="${COLABO_COMMT_SRNO}" 
                        colabo_remark_srno="${COLABO_REMARK_SRNO}" 
                        alarm_action="${ALARM_ACTION}" 
                        alarm_status="${ALARM_STATUS}" 
                        toast_msg="${ALAM_MSG}" 
                        toast_cntn="${isRejectProject ? TagUtil.n2br(alarmItemsHtmlContent) : ""}">
                    <div class="all-setup-picture-type-1"></div>
                    <div class="all-text-wrap-type-1">
                        <div class="all-setup-section-type-1">
                            <span>${Mutil.tag2html(TTL)}</span><em>${Time.fromNow(RGSN_DTTM)}</em>
                        </div>
                        <div class="all-text-wrap-type-2 alarm-tit-ellipsis" ${ListHelper.setDisplay(isContainMsg,"block")}>
                            <i class="${("" !== EMT_CD) ? "icon-" + DetailCode.EMOJI._GB[EMT_CD - 1] : ""}"></i>${ALAM_MSG}</div>
                        <div class="all-text-wrap-type-3">${task_name}${contents}
                        </div>
                        <div class="all-text-wrap-type-3">
                            <span ${ListHelper.setDisplay(isContainImg, "inline-block")}="">
                                <em class="all-setup-icon-type-2"></em>이미지</span>
                            <span ${ListHelper.setDisplay(isContainFile, "inline-block")}="">
                                <em class="all-setup-icon-type-1"></em>파일</span>
                        </div>
                    </div>
                </li>`
}
